import { FC, useMemo } from 'react';

import { CurrencyFormatter } from '@pp/core/src/formatters/CurrencyFormatter';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { formatNumber } from '@pp/core/src/utils/formatters';

export const CrashHelpChapterHowToPlayConnected: FC = () => {
  const compliance = useConfigSlice.compliance();
  const maxPLayerLimitInfo = compliance?.maxPlayerLimitInfo;
  const maxMultiplier = useConfigSlice.tableConfig()?.maxMultiplier;
  const locale = useSettingsSlice.currentLanguage();
  const currency = useGameStateSlice.getCurrency() ?? '';
  const perPayoutBetMaximumLimit = useConfigSlice.tableConfig()?.perPayoutBetMaxLimit ?? 0;

  const perPayoutBetMaxLimit = useMemo(() => {
    return CurrencyFormatter.format(perPayoutBetMaximumLimit, locale, {
      currency: currency,
      avoidTrailingZero: true,
      hideCurrency: true,
    });
  }, [locale, currency, perPayoutBetMaximumLimit]);

  const formattedMultiplier = useMemo(() => {
    return formatNumber(locale, Number(maxMultiplier));
  }, [locale, maxMultiplier]);

  return (
    <div>
      <p>
        <HelpText tk="howToPlayHF.toPlay" />
      </p>
      <p>
        <HelpText tk="howToPlayHF.placingBet" />
      </p>
      <p>
        <HelpText tk="howToPlayHF.totalBet" />
      </p>
      <p>
        <HelpText tk="howToPlayHF.cashout" />
      </p>
      <p>
        <HelpText
          dynamicValues={{
            multipliervalue: `${formattedMultiplier}`,
            perPayoutBetMaxLimit: perPayoutBetMaxLimit,
          }}
          tk="howToPlayHF.winOrCrash"
        />
      </p>
      <p>
        <HelpText tk="howToPlayHF.cashBeforeCrash" markdown />
      </p>
      <p>
        <HelpText tk="howToPlayHF.roundEnd" />
      </p>
      {maxPLayerLimitInfo && <HelpText tk="howToPlayHF.SWISS_MARKET_TEXT" />}
    </div>
  );
};
